export const theme = {
  primary: '#2AB4AA'
};
